/**
 * Protected wrapper for all /hub/settings/* user admin routes
 */

import React from 'react'
import { HubProtectedRoute } from './HubProtectedRoute'
import { HUB_APP_PERMISSIONS } from '../../constants/hub-apps'
import HubSettings from '../../pages/HubSettings'

export default function HubSettingsRoute() {
  return (
    <HubProtectedRoute appPermission={HUB_APP_PERMISSIONS.settings}>
      <HubSettings />
    </HubProtectedRoute>
  )
}
